const {MinimogThemeStyles,MinimogThemeScripts} = window;

class QuickView {
    constructor() {
        this.modal = new MinimogTheme.Modal, this.isOpen = !1, addEventDelegate({
            selector: ".m-product-quickview-button",
            handler: (e, i) => {
                e.preventDefault(), this.target = i, this.toggleLoading(this.target, !0);
                const t = i.dataset.productHandle;
                t && this.fetchHtml(t);
            }
        }), window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (() => {
            this.modal && MinimogTheme.ProductQuickView.close();
        }));
    }
    fetchHtml(e) {
        loadAssetsNew([ MinimogThemeStyles.product ], "quick-view-assets"), fetchSection("product-quickview", {
            url: `${window.MinimogSettings.base_url}products/${e}`
        }).then((e => {
            this.modalContent = e.querySelector(".m-product-quickview");
             console.log(this.target);
            let index= this.target.dataset.index;
            let collection = this.target.dataset.collection;
            let variantId = this.target.dataset.variantid;
            let variantColor = this.target.dataset.variant_color;
            console.log(variantColor);
            let variantSKU = this.target.dataset.variantsku;
            console.log(variantSKU);
            let variantAvailability = this.target.dataset.variantavailability;
            console.log(variantAvailability);
            let variantPrice = this.target.dataset.variantprice;
            console.log(variantPrice);
            let discountPercentage = this.target.dataset.discountpercentage;
            console.log(discountPercentage);
            const addToCartBtn = this.modalContent.querySelector(".m-add-to-cart");
            const selectedVariant = this.modalContent.querySelector("#product-form-product-quickview [data-selected-variant]");
            const variant_inputs = this.modalContent.querySelectorAll(".m-product-option--content input");
            addToCartBtn.setAttribute("data-index", index);
            addToCartBtn.setAttribute("data-collection", collection);
            addToCartBtn.setAttribute("data-variantId", variantId);
            addToCartBtn.setAttribute("data-variantcolor", variantColor);
            addToCartBtn.setAttribute("data-variantsku", variantSKU);
            addToCartBtn.setAttribute("data-variantprice", variantPrice);
            addToCartBtn.setAttribute("data-discountpercentage", discountPercentage);
            addToCartBtn.setAttribute("data-variantavailability", variantAvailability);
            selectedVariant.setAttribute("value", variantId);
            variant_inputs.forEach(input => {
                if (input.value === variantColor) {
                  console.log(variantColor);
                  input.checked = true;
                  let options = input.closest("variant-picker").querySelectorAll("[data-option-name]");
                  options.forEach(option => {
                    let optionName = option.getAttribute("data-option-name");
                     if(optionName == 'Color' || optionName == 'color'){
                  input.closest("variant-color").setAttribute("data-selected-value", variantColor);
                  input.closest("variant-color").querySelector(".option-label--selected").innerHTML = variantColor;
                  }
                  else if(optionName == 'צֶבַע'){
                  input.closest("variant-button").setAttribute("data-selected-value", variantColor);
                  input.closest("variant-button").querySelector(".option-label--selected").innerHTML = variantColor;
                }
                  });
                }
              });
            
            const i = e.querySelector("product-model");
            this.mediaGallery = this.modalContent.querySelector("media-gallery"), loadAssetsNew([ MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker ], "variants-picker", (() => {
                this.modal.appendChild(this.modalContent), this.modal.setWidth("960px"), this.modal.open(), 
                this.toggleLoading(this.target, !1), this.isOpen = !0;
            })), i && loadAssetsNew([ MinimogThemeScripts.productModel, "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css" ], "product-model-assets");
        })).catch(console.error);
    }
    close(e) {
        this.modal.close(e), this.isOpen = !1;
    }
    toggleLoading(e, i) {
        i ? e.classList.add("m-spinner-loading") : e.classList.remove("m-spinner-loading");
    }
}

MinimogTheme.ProductQuickView = new QuickView;